import "./CurrentStats.css";

import { DateTime } from "luxon";
import React from "react";

import cloudPNG from "../../images/cloud.png";
import humidityPNG from "../../images/humidity.png";
import moonPNG from "../../images/moon.png";
import mooncloudPNG from "../../images/mooncloud.png";
import partcloudPNG from "../../images/partcloud.png";
import sunPNG from "../../images/sun.png";
import tempPNG from "../../images/temp.png";
import windPNG from "../../images/wind.png";
import {
  cloudinessFormat,
  humidityFormat,
  rainFormat,
  temperatureFormat,
  windFormat,
} from "../../utils";
import WeatherStat from "./WeatherStat";

const dayCloudIcons = [sunPNG, partcloudPNG, cloudPNG, cloudPNG];
const nightCloudIcons = [moonPNG, mooncloudPNG, cloudPNG, cloudPNG];

const CurrentStats = ({ daily, current, metric, timezone }) => {
  if (!current) return null;
  const cloudIndex = Math.floor((current.conditions.c * 3) / 100);
  const localTime = DateTime.fromISO(current.datetime).setZone(timezone);
  const isDaytime = localTime.hour >= 6 && localTime.hour <= 18;

  const cloudIcon = isDaytime
    ? dayCloudIcons[cloudIndex]
    : nightCloudIcons[cloudIndex];

  return (
    <div className="statcontainer">
      <WeatherStat
        label="Temperature"
        icon={tempPNG}
        value={temperatureFormat(current.conditions.t, metric)}
      />
      <WeatherStat
        label="Humidity"
        icon={humidityPNG}
        value={humidityFormat(current.conditions.h)}
      />
      {typeof current.conditions.wd === "number" && (
        <WeatherStat
          label="Wind Speed"
          icon={windPNG}
          value={windFormat(
            current.conditions.ws,
            current.conditions.wd,
            metric
          )}
        />
      )}
      {typeof current.conditions.c === "number" && (
        <WeatherStat
          label="Cloudiness"
          icon={cloudIcon}
          value={cloudinessFormat(current.conditions.c)}
        />
      )}
      {typeof daily?.rainfall === "number" && (
        <WeatherStat
          label="Rainfall 24h"
          icon={humidityPNG}
          value={rainFormat(daily.rainfall)}
        />
      )}
    </div>
  );
};

export default CurrentStats;
